







import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    reagentsNotIncluded: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
  },
})
